var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 302,
    viewBox: "0 0 162 302"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.6 58h-46.2c-5.5 0-11.6 7.4-11.6 17.3v29.4h57.7v57.4h-57.7v139H46.1v-139H0v-57.3h46.2V75.9c0-41.4 31.1-75 69.3-75h46.2V58h-.1z",
    fill: "#3a5ba2"
  })));
}

export default "data:image/svg+xml,%3c!-- Generator: Adobe Illustrator 19.2.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e %3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e %3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='162px' height='302px' viewBox='0 0 162 302' style='enable-background:new 0 0 162 302;' xml:space='preserve'%3e %3cstyle type='text/css'%3e .st0%7bfill:%233A5BA2;%7d %3c/style%3e %3ctitle%3efacebook-01%3c/title%3e %3cpath class='st0' d='M161.6,58h-46.2c-5.5,0-11.6,7.4-11.6,17.3v29.4h57.7v57.4h-57.7v139H46.1v-139H0v-57.3h46.2V75.9 c0-41.4,31.1-75,69.3-75h46.2V58H161.6z'/%3e %3c/svg%3e";
export { SvgFacebookLogo as ReactComponent };